import React from 'react';
import { exportToExcel } from 'src/utils/Common';
import { Button } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { useTranslation } from 'react-i18next';

function ServiceShopMaterialExcelExport(JsonData) {
  const { t } = useTranslation('overview');

  if (JsonData?.JsonData?.length === 0) {
    return (
      <Button
        size="small"
        variant="contained"
        color="primary"
        disabled={true}
        fullWidth
        endIcon={<CloudDownloadIcon />}
      >
        {t('lblExport')}
      </Button>
    )
  }

  var ExportData = JsonData.JsonData.map(item => {
    return {
      MaterialCode: item.MaterialCode,
      MaterialName: item.MaterialName,
      InStock: item.InStock,
      Ordered: item.Ordered,
      Used: item.Used,
      MaterialLeft: item.MaterialLeft,
      OpenOrder: item.OpenOrder
    }
  });

  return (
    // <ExcelFile element={
    //   <Button
    //     size="small"
    //     variant="contained"
    //     color="primary"
    //     fullWidth
    //     endIcon={<CloudDownloadIcon />}
    //   >
    //     {t('lblExport')}
    //   </Button>}>
    //   <ExcelSheet data={ExportData} name="ServiceShopMaterial">
    //     <ExcelColumn label={t('lblMaterialCode')} value="MaterialCode" />
    //     <ExcelColumn label={t('lblMaterialName')} value="MaterialName" />
    //     <ExcelColumn label={t('lblInStock')} value="InStock" />
    //     <ExcelColumn label={t('lblOrdered')} value="Ordered" />
    //     <ExcelColumn label={t('lblUsed')} value="Used" />
    //     <ExcelColumn label={t('lblLeft')} value="MaterialLeft" />
    //     <ExcelColumn label={t('lblOpenOrder')} value="OpenOrder" />
    //   </ExcelSheet>

    // </ExcelFile>
    <>
      <Button
        size="small"
       variant="contained"
         color="primary"
         fullWidth
         endIcon={<CloudDownloadIcon />}
         onClick={() => exportToExcel(ExportData, 'ServiceShopMaterialExport') }
       >
        Download Data
       </Button>
    </>
  );
}

ServiceShopMaterialExcelExport.propTypes = {

};

export default ServiceShopMaterialExcelExport;
